import React, { useEffect, useRef, useState } from "react";
import NewImage from "assets/images/new-imag.png";
import CircularProgress from 'component/misc/CircularProgress.jsx';
import useBreakpoint from "utils/useBreakPoint.js";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { timeAgo } from "utils/timeAgo.js";
import { translateSectorLabel } from "utils/sectorLabel";

const NewsCard = (props) => {
    const { value,
        viewMode,
        title,
        summary,
        _id,
        progress = 70,
        image_url,
        sectors,
        created_at,
        reading_time_minutes,
        reportCard
    } = props;

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const cardRef = useRef(null);
    const [isCompactWidth, setIsCompactWidth] = useState(false);
    const handleClick = () => {
        if (_id !== undefined && _id !== null) {
            navigate(`/news/news-view/${_id}`);
        }
    };
    const breakpoint = useBreakpoint();
    const stackLayout = breakpoint === "mobile" || isCompactWidth;

    useEffect(() => {
        if (typeof ResizeObserver === "undefined") return;
        if (!cardRef.current) return;
        const el = cardRef.current;
        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const width = entry.contentRect?.width ?? el.clientWidth;
                setIsCompactWidth(width < 400);
            }
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const fixedImageHeight = viewMode === "list" ? null : 190;
    const shouldFixedHeight = viewMode === "list" && !isCompactWidth;
    const imageContainerHeight = shouldFixedHeight
        ? "223px"
        : fixedImageHeight
            ? `${fixedImageHeight}px`
            : "100%";

    return (
        <div
            ref={cardRef}
            className={`news-card overflow-hidden rounded-4 `}
            onClick={handleClick}
            style={{
                cursor: _id ? "pointer" : "default",
                height: shouldFixedHeight ? "223px" : "auto",
            }}
        >
            <div className="row g-0">
                {/* Left image */}
                <div
                    className={`${viewMode === "list" ? "col-4" : "col-12"} news_image_box`}
                    style={{
                        height: imageContainerHeight,
                        overflow: "hidden",
                    }}
                >
                    <img
                        src={image_url}
                        alt={title || t("news.top.imageAlt")}
                        className="w-100 h-100 object-fit-cover"
                        style={{ objectPosition: "center", objectFit: "cover" }}
                    />
                </div>

                {/* Right content */}
                <div className={`${viewMode === "list" ? "col-8" : "col-12"} card_detail_box text-white d-flex flex-column justify-content-between `}>
                    <div>
                        <h4 className="fw-light news_card_title">
                            {title || t("news.card.fallbackTitle")}
                        </h4>
                        <p className="text-whitem fw-light card_description">
                            {summary || t("news.card.fallbackSummary")}
                        </p>
                    </div>
                    {(!stackLayout && (breakpoint === "tablet" || breakpoint === "laptop")) &&
                        (<div className="news_detail d-flex align-items-center justify-content-between gap-2 flex-wrap ">
                            <div className="category_wrap d-flex gap-3 align-items-center small   ">
                                <p className='text-white mb-0'>
                                    <span className='active_news '></span>
                                    {timeAgo(created_at)}
                                </p>
                                {sectors && sectors.slice(0, 2).map((sector, idx) => (
                                    <span key={idx} className='category rounded-4 text-white'>{translateSectorLabel(sector, i18n.resolvedLanguage || i18n.language)}</span>
                                ))}
                            </div>
                            <div className="category_wrap d-flex align-items-center gap-3 small  ">
                                <span className='post_time'>{reading_time_minutes} {t("news.readTime.min")}</span>
                                <CircularProgress progress={progress} />
                            </div>
                        </div>)
                    }
                </div>
                {stackLayout &&
                    <div className="news_detail d-flex flex-column gap-2 p-3">
                        <div className="category_wrap d-flex align-items-center justify-content-between small w-100">
                            <p className='text-white mb-0 d-flex align-items-center gap-2'>
                                <span className='active_news '></span>
                                {timeAgo(created_at)}
                            </p>
                            <div className="d-flex align-items-center gap-3">
                                <span className='post_time'>{reading_time_minutes} {t("news.readTime.min")}</span>
                                <CircularProgress progress={progress} />
                            </div>
                        </div>
                        {sectors && sectors.slice(0, 2).map((sector, idx) => (
                            <div className="category_wrap w-100" key={idx}>
                                <span className='category text-white rounded-4 d-block w-100 text-center'>{translateSectorLabel(sector, i18n.resolvedLanguage || i18n.language)}</span>
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    )
}

export default NewsCard
